import Wrapper from "../../layout/Wrapper";
import DashboardComponent from "../../screens/dashboard";

import MetaComponent from "../../components/common/MetaComponent";

const metadata = {
  title: "Dashboard",
  description: "",
};

export default function ChangePassword() {
  return (
    <Wrapper>
    <MetaComponent meta={metadata} />
      <DashboardComponent />
    </Wrapper>
  );
}